const ProductImageDisabled = () => {
  return <div className="image-upload-wrap-disabled"></div>;
};

export default ProductImageDisabled;
